/*
author:wang.jiang 2016-1-16
 */
'use strict';
angular.module('editctrNewspaperPicModule', [
    'editctrNewspaperRouterModule',
]).controller('EditctrNewspaperPicCtrl', [
    '$scope', 
    'beforeonload', 
    '$sce', 
    '$element', 
    '$window', 
    '$compile', 
    '$state', 
    '$timeout', 
    '$location', 
    '$anchorScroll', 
    '$stateParams', 
    '$validation', 
    '$filter', 
    'trsHttpService',
    'jsonArrayToStringService',
    'modalDialog',
    '$q',
    'initPaperDataService',
    'iWoService',
    'editingCenterService',
    'initeditctrBtnsService',
    'filterEditctrBtnsService',
    'newsDictionBtnService',
    'newsEditBtnService',
    'editNewspaperService',
    'storageListenerService',
    'editIsLock',
    'localStorageService',
    'editPictureService',
    'editcenterRightsService',
    'sensitiveWordCheckService',
    '$sessionStorage',
    'newMediaService',
    'messagePublishService',
    function(
        $scope,
        beforeonload, 
        $sce,
        $element, 
        $window, 
        $compile,
        $state,
        $timeout,
        $location,
        $anchorScroll,
        $stateParams,
        $validation, 
        $filter, 
        trsHttpService, 
        jsonArrayToStringService, 
        modalDialog, 
        $q, 
        initPaperDataService, 
        iWoService, 
        editingCenterService, 
        initeditctrBtnsService,
        filterEditctrBtnsService,
        newsDictionBtnService,
        newsEditBtnService,
        editNewspaperService,
        storageListenerService,
        editIsLock,
        localStorageService,
        editPictureService,
        editcenterRightsService,
        sensitiveWordCheckService,
        $sessionStorage,
        newMediaService,
        messagePublishService
    ) {
        initStatus();
        initData();
        editingCenterService.disabledDndDropOnOutlist($scope);

        $scope.moveUploadImg = function(index) {
            $scope.list.DOC_PICTURELIST.splice(index, 1);
        };
        // 锚点切换开始
        $scope.goto = function(id) {
            $location.hash(id);
            $anchorScroll();
        };

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGECOUNT: 20
            };
            $scope.status = {
                data: {
                    meataInfo: {},
                    docgenreOptions: []
                },
                newsFormError: [],
                newsPaperInfo: {},
                isawaitrevise: $state.params.isawaitrevise,
                openBtn: true,
                switch: 'manuscriptInfo', // 默认选中稿件信息
                version: [],
                copyVersion: [],
                uploaderImgSelected: [],
                isEditDraft: !!$stateParams.papermetadataid,
                metadataid: $stateParams.papermetadataid,
                comment: {
                    comment: [],
                    voiceObj: {},
                    hasMore: false,
                    currPage: 1,
                },
                path: {
                    '-1': 'editingCenterIwoPersonalVersionTime',
                    '1': 'editingCenterAppPersonalVersionTime',
                    '2': 'editingCenterWebsitePersonalVersionTime',
                    '3': 'editingCenterPaperPersonalVersionTime',
                    '4': 'editingCenterWeixinPersonalVersionTime'
                },
                isCheckSensitiveWords: false,
                sensitiveWordTit: '敏感词校验',
                heimaCheckTit: '错别字校对',
                isFusionEditor: $state.current.name === 'fusionatlas', // 是否来自融合编辑器
                // isHasHeimaCheck: false,
                toggleSubTitle: true, // 默认展示文章肩题和副题
                isShowTrsDraft: $stateParams.newspapertype === '2' ? $stateParams.newspapertype : null,
            };
            $scope.data = {
                userName: '',
                KEYWORDS: []
            };
            if ($scope.status.isFusionEditor) {
                $scope.params = {
                    'serviceid': 'mlf_fusioncreate',
                    'methodname': 'getPaperFusionDoc',
                    'sourceDocId': $scope.data.sourceDocId || $stateParams.iwometadataid
                };
            } else {
                $scope.params = {
                    'serviceid': 'mlf_paper',
                    'methodname': 'queryViewDatas',
                    'MetaDataIds': $stateParams.papermetadataid,
                };
            }
            $scope.uploaderImgSelected = [];
            // 初始化按钮点击
            $scope.handleBtnClick = function(funname) {
                eval('$scope.' + funname + '()');
            };
            // 初始化稿件体裁
            iWoService.initData().then(function(data) {
                $scope.docgenre = [];
                angular.forEach(data.DocGenre, function(data, key) {
                    $scope.docgenre.push({
                        value: data.desc,
                        name: data.value
                    });
                });
                initDocgenre();
            });
            emitCloseWindow();
            $scope.editFlag = {
                media: 'newspaper', 
                docType: 'atlas',
            };
        }

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            editingCenterService.allAppCloseWindow($scope, {typeName: 'paper', saveLocal: false});
        }

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            // 判断是否有修订完成权限
            if ($scope.status.isawaitrevise) {
                editcenterRightsService.initIwoListBtn('iwo.xiuding').then(function(rights) {
                    $scope.status.btnRights = rights;
                });
            }
            if (!$scope.status.isFusionEditor) {
                (angular.isDefined($stateParams.papermetadataid) ? initEditData() : initNewData()).then(function() {
                    beforeonload.beforeonloadAlert($scope);
                    loadDirective();
                });
                initBtn();
            } else {
                loadDirective();
            }
            // 融合编辑器下获取评审意见
            if ($stateParams.iwometadataid) {
                getComment($stateParams.iwometadataid, $scope.status.comment.currPage);
            }
            $anchorScroll.yOffset = 63;
        }

        /**
         * [initEditData description] 编辑数据
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initEditData(dealWithListFun) {
            var deferred = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.list = data[0] || data;
                $scope.data.remarks = $scope.list.REMARKS;
                document.title = $scope.list.TITLE = $scope.list.TITLE.split('<br />').join('\n');
                $scope.list.GENREOBJ = {};
                $scope.list.GENREOBJ.name = $scope.list.GENREDOC;
                $scope.GENREDOC = $scope.list.GENREOBJ;
                // 处理上传图集多余属性问题
                examImg();
                getVersion();
                // 获取评审意见
                if (!$stateParams.iwometadataid) {
                    getComment($stateParams.papermetadataid, $scope.status.comment.currPage);
                }
                // 融合编辑器下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                deferred.resolve();
            });
            editIsLock.lockDraft($stateParams.papermetadataid);
            return deferred.promise;
        }

        /**
         * [initNewData description] 新建数据
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initNewData(dealWithListFun) {
            var deffer = $q.defer();
            $scope.list = initPaperDataService.initPic();
            // 融合编辑器下处理list
            if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
            deffer.resolve();
            return deffer.promise;
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function() { // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.atlasForm.$error) {
                errorArray.push(error);
            }
            $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
            if ($scope.status.newsFormError.length != errorArray.length) { // 长度不相等说明表单errorname发生变化
                $scope.status.newsFormError = errorArray;
            }
            return $scope.status.newsFormError; // 返回
        };

        /**
         * [save description] 保存稿件
         * @param   {[boolean]}  flag  [flag description] 保存时是否加锁
         * @return  {[type]}           [return description]
         */
        $scope.save = function(flag) {
            var defer = $q.defer();
            save(flag).then(function() {
                if ($scope.$root.cureditpage === undefined || $scope.$root.cureditpage === 'newspaperpic') {
                    if (flag) {
                        editIsLock.lockDraft($stateParams.papermetadataid);
                    }
                    getVersion();
                }
                defer.resolve();
            }, function() {
                defer.reject();
            });
            return defer.promise;
        };

        /**
         * [newsDraftZhuanBan description] 转版操作
         * @return  {[type]}  [return description]
         */
        $scope.newsDraftZhuanBan = function(){
            newMediaService.zhuanBan($scope).then(() => {
                save().then(() => {
                    messagePublishService.publish('doEditPageOperation');
                });
            });
        };
        
        /**
         * [examImg description]检验图片，处理上传图集多余属性问题
         * @return {[type]} [description]
         */
        function examImg() {
            if ($scope.list.DOC_PICTURELIST != '[]') {
                angular.forEach($scope.list.DOC_PICTURELIST, function(data, index) {
                    angular.forEach($scope.list.DOC_PICTURELIST[index], function(value, key) {
                        if (key !== 'APPFILE' && key !== 'APPDESC' && key !== 'PERPICURL' && key !== 'APPENDIXID') {
                            delete $scope.list.DOC_PICTURELIST[index][key];
                        }
                    });
                });
            } else {
                $scope.list.DOC_PICTURELIST = [];
            }
        }

        /**
         * [calculateWordNum description]计算字数
         * @return {[type]} [description]
         */
        function calculateWordNum() {
            var len = 0;
            angular.forEach($scope.list.DOC_PICTURELIST, function(value, key) {
                if (angular.isDefined(value.APPDESC)) {
                    len += value.APPDESC.length;
                }
            });
            $scope.list.DOCWORDSCOUNT = len;
        }

        /**
             * [save description] 保存方法
             * @param   {[type]}  flag  [flag description]
             * @return  {[type]}        [return description]
             */
        function save(flag) {
            var deferred = $q.defer();
            $validation.validate($scope.atlasForm.authorForm);
            $scope.atlasForm.$pending = {};
            $validation.validate($scope.atlasForm)
                .success(function() {
                    sensitiveWordCheckService.sensitiveWords($scope).then(function(sensitiveWords) {
                        $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                        $scope.list.SENSITIVEWORDS = sensitiveWords;
                        if (angular.isDefined($scope.list.EXTPROPERTY)) {
                            $scope.list.EXTPROPERTY.SENSITIVEWORDS = sensitiveWords;
                        } else {
                            $scope.list.EXTPROPERTY = {
                                SENSITIVEWORDS: sensitiveWords
                            };
                        }
                        $scope.atlasForm.$setPristine();
                        $scope.status.openBtn = false;
                        calculateWordNum();
                        $scope.list.DOCRELTIME = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm').toString();
                        var list = angular.copy($scope.list);
                        // 标题回车处理成</br> 存入数据库里
                        list.TITLE = list.TITLE.split('\n').join('<br />');

                        var saveParams = angular.copy(list);
                        saveParams.serviceid = $scope.status.isFusionEditor ? 'mlf_fusionpaper' : 'mlf_paper';
                        saveParams.methodname = $scope.status.isFusionEditor ? 'saveFictitionsPicsDoc' : 'savePicDocument';
                        saveParams.SourceDocId = $scope.data.sourceDocId || $stateParams.iwometadataid;
                        saveParams.ObjectId = $stateParams.papermetadataid;
                        saveParams.CONTRIBUTORSAUTHER = $scope.data.userName;
                        delete saveParams.CRDEPT;
                        delete saveParams.DOCTYPE;
                        // delete saveParams.METADATAID;
                        delete saveParams.LOG_OPERATION;
                        delete saveParams.OBJ_VERSION;
                        // 处理发稿单作者信息空数据提交问题
                        if (angular.isDefined(saveParams.FGD_AUTHINFO[0]) && (!angular.isDefined(saveParams.FGD_AUTHINFO[0].USERNAME) || saveParams.FGD_AUTHINFO[0].USERNAME === '')) {
                            saveParams.FGD_AUTHINFO = [];
                        }
                        saveParams.SPECIALDOC = $scope.data.specialDoc;
                        saveParams.ORIGINALTYPE = $scope.data.originType;
                        // 处理发稿单作者信息空数据提交问题
                        if ($scope.status.isFusionEditor) {
                            delete saveParams.ISNOPAYMENT;
                            delete saveParams.FGD_EDITINFO;
                            delete saveParams.FGD_AUTHINFO;
                            delete saveParams.DOCGENRE;
                            // NEWSSOURCES为空时传空字符串
                            // saveParams.NEWSSOURCES = !$scope.list.NEWSSOURCES.SRCNAME ? '' : angular.copy($scope.list.NEWSSOURCES);
                            saveParams.METADATAID = $stateParams.papermetadataid || '0';
                            saveParams.serviceid = 'mlf_fusionpaper';
                            saveParams.methodname = 'saveFictitionsPicsDoc';
                            saveParams.SourceDocId = $scope.data.sourceDocId || $stateParams.iwometadataid;
                        } else {
                            saveParams.serviceid = 'mlf_paper';
                            saveParams.methodname = 'savePicDocument';
                        }
                        list.PICTURELIST = list.DOC_PICTURELIST; // PICTURELIST是做新媒体渠道时添加的，为了兼容性，需把两边的值保持一致
                        saveParams = jsonArrayToStringService.jsonArrayToString(saveParams);
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), saveParams, 'post').then(function(data) {
                            $scope.status.openBtn = true;
                            if ($scope.status.isFusionEditor) {
                                $scope.list.METADATAID = data.METADATAID;
                                $scope.params.MetaDataIds = data.METADATAID;
                                $stateParams.papermetadataid = data.METADATAID;
                            } else {
                                // data = eval(data);
                                $scope.list.METADATAID = data.METADATAID;
                                $scope.params.MetaDataIds = data.METADATAID;
                                $stateParams.papermetadataid = data.METADATAID;
                            }
                            // 保存稿件成功后
                            if (flag) {
                                if (!$scope.status.isFusionEditor) {
                                    storageListenerService.addListenerToNewspaper('save');
                                    $state.transitionTo($state.current, $stateParams, {
                                        reload: false
                                    });
                                    modalDialog.saveModel('保存成功', '', 'success');
                                }
                            }
                            deferred.resolve(data);
                            beforeonload.refresh($scope);
                        }, function(data) {
                            $scope.status.openBtn = true;
                            deferred.reject(data);
                        });
                    }, function() {
                        $scope.status.isCheckSensitiveWords = Math.random();
                        deferred.reject();
                    });
                }).error(function() {
                    editingCenterService.checkSaveError($scope.atlasForm, $element, $scope); // 定位输入错的表单位置
                    deferred.reject({
                        plat: '报纸'
                    });
                });
            return deferred.promise;
        }

        /**
         * [close description]关闭页面
         * @return {[type]} [description]
         */
        $scope.close = function() {
            editingCenterService.closeWinow($scope.atlasForm.$dirty).then(function() {
                save().then(function() {
                    storageListenerService.addListenerToNewspaper('save');
                    editIsLock.normalLock($stateParams.papermetadataid).then(function(data) {
                        $window.close();
                    });
                });
            }, function() {
                editIsLock.normalLock($stateParams.papermetadataid).then(function(data) {
                    $window.close();
                });
            });
        };

        /**
         * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
         * @param  {[type]}  key [description] 操作日志或流程版本的数据
         * @return {Boolean}     [description]
         */
        $scope.isShowVersion = function(key) {
            if (key === undefined) {
                return false;
            } else {
                for (var i in key) {
                    return true;
                }
                return false;
            }
        };
        // };

        /**
             * [initDocgenre description] 初始化发稿单
             * @return  {[type]}  [return description]
             */
        function initDocgenre() {
            trsHttpService.httpServer('./editingCenter/properties/metadataEnum.json', {}, 'get').then(function(data) {
                angular.forEach(data.DocGenre, function(value, key) {
                    $scope.status.data.docgenreOptions.push({
                        value: value.value,
                        name: value.desc
                    });
                });
            });
        }
        // 关键词处理
        $scope.invalidTag = function(tag) {
            var len = $scope.KEYWORDS.length;
            var reg = /^[^<>\\\/\'\"]*$/;
            if (len > 9) {
                $scope.vm.isShowKeywordTips = true;
                $scope.vm.keywordsTips = '关键词个数不能超过10个';
                return false;
            } else if (tag.name.length > 20) {
                $scope.vm.isShowKeywordTips = true;
                $scope.vm.keywordsTips = '单个关键词长度不能超过20';
            } else if (!reg.test(tag.name)) {
                $scope.vm.keywordsTips = '不允许使用特殊字符';
                $scope.vm.isShowKeywordTips = true;
            }
        };
        // 不发稿费
        $scope.updateCKSelection = function() {
            $scope.list.ISNOPAYMENT === '1' ? $scope.list.ISNOPAYMENT = '0' : $scope.list.ISNOPAYMENT = '1';
        };
        // 稿件体裁
        $scope.draftType = function() {
            $scope.list.DOCGENRE = angular.copy($scope.GENREDOC).value;
        };

        /**
             * [loadDirective description] 动态加载指令
             * @return  {[type]}  [return description]
             */
        function loadDirective() {
            editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
            if (!$scope.status.isFusionEditor) {
                var draftList = '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="atlasForm"></editor-dir>' +
                    '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            }
        }

        /**
             * [getVersion description] 获取流程版本与操作日志
             *
             * @param   {[type]}  more  [more description]
             *
             * @return  {[type]}        [return description]
             */
        function getVersion(more) {
            editingCenterService.getEditVersionTime($stateParams.iwometadataid || $stateParams.papermetadataid, $scope.page, $scope.status.copyVersion).then(function(data) {
                if (more) {
                    $scope.data.version = concatVersion(data);
                    // $scope.data.version = $scope.data.version.concat(data);
                } else {
                    $scope.data.version = data;
                }
                $scope.page = data.page;
                $scope.data.copyVersion = data.copyArray;
                $scope.status.hasVersionTime = true;
                $scope.data.lastVersionid = data.lastVersionid;
            });
        }

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function() {
            $scope.page.CURRPAGE++;
            getVersion('more');
        };

        /**
             * [concatVersion description] 点击加载更多把老数据和新数据拼接
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
        function concatVersion(data) {
            var lastVersion = $scope.data.version;
            for (var i in data.group) {
                var key = i;
                var isAdd = false;
                for (var j in lastVersion.group) {
                    if (j == key) {
                        isAdd = true;
                    }
                }
                lastVersion.group[i] = isAdd ? data.group[i].concat(lastVersion.group[i]) : data.group[i];
            }
            for (var m in data.operationLog) {
                var Key = m;
                var isadd = false;
                for (var n in lastVersion.operationLog) {
                    if (n == Key) {
                        isadd = true;
                    }
                }
                lastVersion.operationLog[m] = isadd ? data.operationLog[m].concat(lastVersion.operationLog[m]) : data.operationLog[m];
            }
            return lastVersion;
        }

        /**
             * [getComment description] 获取评审意见
             *
             * @param   {[type]}  id        [id description]
             * @param   {[type]}  currPage  [currPage description]
             *
             * @return  {[type]}            [return description]
             */
        function getComment(id, currPage) {
            editingCenterService.getComment(id, currPage).then(function(data) {
                if (angular.isDefined($scope.status.comment.comment[$scope.status.comment.comment.length - 1]) && $filter('date')($scope.status.comment.comment[$scope.status.comment.comment.length - 1].day, 'yyyy-MM-dd').toString() == $filter('date')(data.comment[0].day, 'yyyy-MM-dd').toString()) {
                    $scope.status.comment.comment[$scope.status.comment.comment.length - 1].times = $scope.status.comment.comment[$scope.status.comment.comment.length - 1].times.concat(data.comment[0].times);
                    data.comment.shift();
                }
                $scope.status.comment['comment'] = $scope.status.comment['comment'].concat(data.comment);
                $scope.status.comment.hasMore = data.hasMore;
                for (var i in data.voiceObj) {
                    $scope.status.comment.voiceObj[i] = data.voiceObj[i];
                }
            });
        }

        /**
         * [getComment description]获取评审意见
         * @return {[type]} [description]
         */
        $scope.getLoadMoreComment = function() {
            $scope.status.comment.currPage += 1;
            getComment($stateParams.papermetadataid, $scope.status.comment.currPage);
        };

        /**
         * [trustUrl description]信任url
         */
        $scope.trustUrl = $sce.trustAsResourceUrl;

        /**
         * [initBtn description]获得底部可以操作的权限按钮
         * @return {[type]} [description]
         */
        function initBtn() {
            if ($scope.status.isawaitrevise) { // 待修订状态的编辑页只有保存按钮和修订按钮，在此处加入保存按钮
                addBtn();
                return;
            }
            editingCenterService.getSiteInfo($stateParams.paperid).then(function(data) {
                $scope.status.newInformation = data;
                $scope.methodnameArray = ['paper.dyg', 'paper.jrg', 'paper.sbg', 'paper.yqg'];
                $scope.dictionaryArray = [newsDictionBtnService.initStandDraftBtn(), newsDictionBtnService.initTodayDraftBtn(), newsDictionBtnService.initPageDraftBtn()];
                $scope.newsArray = newsEditBtnService.initDraftArrays()[$stateParams.newspapertype];
                if (angular.isDefined($stateParams.isfusion) || ($stateParams.newspapertype == 2 && $scope.status.newInformation.ISDUOJISHEN == 0)) {
                    $scope.newsArray.length = 1;
                }
                initeditctrBtnsService.initNewsData($scope.methodnameArray[$stateParams.newspapertype], $stateParams.paperid, $stateParams.channelid).then(function(data) {
                    initeditctrBtnsService.initBtns(data, $scope.dictionaryArray[$stateParams.newspapertype]).then((btns) => {
                        $scope.btnStatus = btns;
                        $scope.arrayBtn = filterEditctrBtnsService.filterBtn($scope.btnStatus, $scope.newsArray);
                        addBtn();
                    });
                });
            });
            // editcenterRightsService.initNewspaperListBtn('paper.sbg', $stateParams.paperid).then(function(data) {
            //     $scope.status.hasHeimaRight = !!data['paper.sbg.check'] ? 'true' : 'false';
            // });
        }

        /**
             * [addBtn description] 添加保存关闭按钮
             * @return  {[type]}  [return description]
             */
        function addBtn() {
            $scope.arrayBtn = $scope.arrayBtn ? $scope.arrayBtn : [];
            $scope.arrayBtn.unshift({
                RIGHTINDEX: 'save',
                OPERDESC: '保存',
                OPERNAME: '保存',
                OPERFUN: 'save'
            });
            $scope.arrayBtn.push({
                RIGHTINDEX: 'close',
                OPERDESC: '保存并关闭',
                OPERNAME: '保存并关闭',
                OPERFUN: 'saveAndClose'
            });
        }

        /**
        * [savethenclose description] 保存并关闭
        * @return  {[type]}  [return description]
        */
        $scope.saveAndClose = function(){
            editingCenterService.saveAndClose($scope.save, 0);
        };
        // 图片上移开始
        $scope.upMove = function(index) {
            if (index !== 0) {
                swapItems($scope.list.DOC_PICTURELIST, index, index - 1);
            }
        };

        // 图片下移开始
        $scope.downMove = function(index) {
            if (index !== $scope.list.DOC_PICTURELIST.length - 1) {
                swapItems($scope.list.DOC_PICTURELIST, index, index + 1);
            }
        };

        /**
             * [swapItems description]
             * @param   {[type]}  list    [list description]
             * @param   {[type]}  index1  [index1 description]
             * @param   {[type]}  index2  [index2 description]
             * @return  {[type]}          [return description]
             */
        function swapItems(list, index1, index2) {
            list[index1] = list.splice(index2, 1, list[index1])[0];
        }

        /**
         * [photoCrop description] 编辑裁剪图片
         * @param   {[type]}  image  [image description]
         * @param   {[type]}  index  [index description]
         * @return  {[type]}         [return description]
         */
        $scope.photoCrop = function(image, index) {
            editPictureService.editPicture(angular.copy(image), undefined, function(img) {
                $scope.list.DOC_PICTURELIST[index].APPFILE = img.imgName;
                $scope.list.DOC_PICTURELIST[index].PERPICURL = img.imgSrc;
                $scope.list.DOC_PICTURELIST[index].SRCFILE = img.srcFile;
                delete $scope.list.DOC_PICTURELIST[index].APPENDIXID;
            });
        };

        /**
         * [newsDraftShangBan description] 稿件上版
         * @return  {[type]}  [return description]
         */
        $scope.newsDraftShangBan = function () {
            newMediaService.shangBan($scope).then(() => {
                save().then(() => {
                    messagePublishService.publish('doEditPageOperation');
                });
            });
        };

        /**
         * [newsDraftDaiYong description] 待用操作
         * @return  {[type]}  [return description]
         */
        $scope.newsDraftDaiYong = function() {
            newMediaService.daiYong($scope).then(() => {
                save().then(() => {
                    messagePublishService.publish('doEditPageOperation');
                });
            });
        };

        /**
        * [newsDraftCheGao description] 撤稿操作
        * @return  {[type]}  [return description]
        */
        $scope.newsDraftCheGao = function() {
            newMediaService.newsPaperChegao($scope).then(() => {
                $scope.save(false).then(() => {
                    messagePublishService.publish('doEditPageOperation');
                });
            });
        };

        /**
         * [newsDraftZhaoPai description] 签发照排
         * @return  {[type]}  [return description]
         */
        $scope.newsDraftZhaoPai = function() {
            save().then(() => {
                editIsLock.lockDraft($state.params.papermetadataid);
                newMediaService.newsSign($scope);
            });
        };

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function(item) {
            var path = $scope.status.path[item.MEDIATYPE];
            var params = {
                objectversionid: item.OBJECTVERSIONID
            };
            var url = $state.href(path, params);
            item.url = url;
        };

        /**
         * [checkSensitiveWord description]点击校验敏感词按钮
         * @return {[type]} [description]
         */
        $scope.checkSensitiveWord = function() {
            if ($scope.status.sensitiveWordTit == '敏感词校验') {
                sensitiveWordCheckService.sensitiveWords($scope).then(function(sensitiveWords) {
                    $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                    // $scope.atlasForm.$setPristine();
                    /* if ($scope.list.ISCONTAINSENSITIVEWORDS) {*/
                    $scope.status.isCheckSensitiveWords = Math.random();
                    $scope.status.sensitiveWordTit = '取消敏感词校验';

                    /* }*/
                });
            } else {
                // 取消敏感词校验
                cancelCheckSensitiveWord();
            }
        };

        /**
         * [cancelCheckSensitiveWord description]取消敏感词校验
         * @return {[type]} [description]
         */
        function cancelCheckSensitiveWord() {
            $scope.status.isCheckSensitiveWords = false;
            $('.hasSensitiveWordInputBox').find('span.ng-scope').addClass('ng-hide').html('');
            $('.hasSensitiveWordInputBox').removeClass('hasSensitiveWordInputBox');
            $('.hasSensitiveWord').removeClass('hasSensitiveWord');
            $scope.status.sensitiveWordTit = '敏感词校验';

            /* $(".bigFaceDetail").attr("style", "");*/
            $('.bigFaceDetailLeft').removeClass('col-md-6').removeClass('col-sm-6').addClass('col-sm-9').addClass('col-md-9').addClass('col-sm-8');
            $('.bigFaceDetailRigth').attr('style', 'display:block');
        }

        /**
         * [sendNews description] 传稿操作
         * @return  {[type]}  [return description]
         */
        $scope.sendNews = function() {
            newMediaService.newsChuanGao($scope).then(() => {
                $scope.save(false).then(() => {
                    messagePublishService.publish('doEditPageOperation');
                });
            });

        };

        // /**
        //  * [transDraft description]传稿
        //  * @return  {[type]}  [return description]
        //  */
        // function transDraft() {
        //     var userInfo = $sessionStorage.get('curUserInfo');
        //     var transferUserObj = localStorageService.get('transferUser') || {};
        //     var records = transferUserObj[userInfo.ID];
        //     if (!records) {
        //         records = [];
        //     }
        //     editNewspaperService.draft({
        //         title: '传稿',
        //         records: records,
        //         confirm: true
        //     }, function(obj) {
        //         var params = {
        //             serviceid: 'mlf_paper',
        //             methodname: 'transferMetaDatas',
        //             paperid: $state.params.paperid,
        //             transferUser: JSON.stringify({
        //                 'USERID': obj.ID,
        //                 'USERNAME': obj.UNAME,
        //                 'TRUENAME': obj.USERNAME
        //             }),
        //             metadataids: $scope.list.METADATAID,
        //         };
        //         $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function(data) {
        //             modalDialog.multiReportsAlert(data, function(data) {
        //                 storageListenerService.addListenerToNewspaper();
        //                 $window.close();
        //             });
        //         });
        //     });
        // }

        /**
         * [revise description] 修订
         * @return {[type]} [description]
         */
        $scope.revise = function() {
            modalDialog.confirmModal('修订', '确认修订?', function() {
                save().then(function() {
                    var params = {
                        serviceid: 'mlf_modifydoc',
                        methodname: 'paperModifyDocsFinished',
                        PaperDocIds: $stateParams.papermetadataid
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        modalDialog.alertType('修订成功', '', 'success', false, function() {
                            storageListenerService.addListenerToNewspaper('xiuding');
                            $window.close();
                        }, '', 1500);
                    }, function() {
                        editIsLock.lockDraft($stateParams.papermetadataid);
                    });
                }, function() {
                    editIsLock.lockDraft($stateParams.papermetadataid);
                });
            });
        };

        /**
         * [getSuggestions description]获取suggestion
         * @param  {[str]} viewValue [description]输入框内输入值
         * @return {[type]}           [description]
         */
        $scope.getSuggestions = function(viewValue) {
            return editingCenterService.getRecentUsageSources(viewValue);
        };

        /* 融合编辑器额外功能开始*/
        if ($scope.status.isFusionEditor) {

            /**
             * [pageCantEdit description] 已提交渠道编辑页不能编辑
             * @param  {[type]} type [description] 稿件信息或属性信息
             * @return {[type]}      [description]
             */
            $scope.pageCantEdit = function(type) {
                $timeout(function() {
                    if (type == 'manuscriptInfo') {
                        var manuHeight = $('.newspaper_manuscript_info').height();
                        var manuWidth = $('.newspaper_manuscript_info').width();
                        $('.pageCantEdit').find('.cantEditPart').height(manuHeight).width(manuWidth);
                        $('.newspaper_manuscript_info').resize(function() {
                            $('.pageCantEdit').find('.cantEditPart').height($(this).height());
                        });
                    } else if (type == 'attrInfo') {
                        var attrHeight = $('.newspaper_attr_info').height();
                        var attrWidth = $('.newspaper_attr_info').width();
                        $('.pageCantEdit').find('.cantEditPart').height(attrHeight).width(attrWidth);
                        $('.newspaper_attr_info').resize(function() {
                            $('.pageCantEdit').find('.cantEditPart').height($(this).height());
                        });
                    }
                }, 300);
            };

            /**
             * [initData description] 融合编辑器切换渠道时的初始化数据
             * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
             * @return {[type]} [description]
             */
            $scope.initData = function(dealWithListFun) {
                var defer = $q.defer();
                if (angular.isDefined($stateParams.papermetadataid)) {
                    initEditData(dealWithListFun).then(function() {
                        defer.resolve();
                    });
                } else {
                    initNewData(dealWithListFun);
                    defer.resolve();
                }
                return defer.promise;
            };

            /**
             * [loadFgd description] 加载发稿单
             * @return {[type]} [description]
             */
            $scope.loadFgd = function() {
                var draftList = '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="atlasForm"></editor-dir>' +
                    '<editor-auth-dir originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0" author="list.FGD_AUTHINFO"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            };

            /* 批量上传图片模态框*/
            $scope.multiImgsUploader = function() {
                // 对接媒资库
                let options = {
                    resourceType: '0',
                    isMulti: true
                };
                editingCenterService.mediaSelector(options).then(function(result) {
                    var picList = [];
                    for (var l = 0; l < result.list.length; l++) {
                        // 我的图片已经选中的
                        var imgName = result.list[l].previewurl.substring(result.list[l].previewurl.lastIndexOf('\/') + 1).split('?')[0];
                        picList.push({
                            PERPICURL: result.list[l].resourceurl,
                            APPFILE: imgName,
                            APPDESC: result.list[l].resourcetitle,
                            APPSIZE: result.list[l].resourcesize,
                            meiziId: result.list[l].resourceid,
                            relationId: result.list[l].relationid
                        });
                    }
                    $scope.list.DOC_PICTURELIST = $scope.list.DOC_PICTURELIST.concat(picList);
                });
            };
            // 批量删除上传后的图片
            $scope.batchDelete = function() {
                modalDialog.confirmModal('删除', '是否确认删除选择的图片', function() {
                    var temp = [];
                    angular.forEach($scope.list.DOC_PICTURELIST, function(data, index, array) {
                        if ($scope.status.uploaderImgSelected.indexOf(data) < 0) {
                            temp.push(data);
                        }
                    });
                    $scope.list.DOC_PICTURELIST = temp;
                    $scope.status.uploaderImgSelected = [];
                });
            };

            /**
             * [multiImgsDownload description] 下载原图
             * @return {[type]} [description]
             */
            $scope.multiImgsDownload = function() {
                $scope.loadingPromise = editingCenterService.downloadOrgImgList($scope.status.uploaderImgSelected, 'PERPICURL', 'APPDESC');
            };
            // 全选批量上传后的图片
            $scope.selectAllImg = function() {
                $scope.status.uploaderImgSelected = $scope.status.uploaderImgSelected.length === $scope.list.DOC_PICTURELIST.length ? [] : [].concat($scope.list.DOC_PICTURELIST);
            };
            // 选择批量上传后的图片
            $scope.selectImg = function(item) {
                if ($scope.status.uploaderImgSelected.indexOf(item) < 0) {
                    $scope.status.uploaderImgSelected.push(item);
                } else {
                    $scope.status.uploaderImgSelected.splice($scope.status.uploaderImgSelected.indexOf(item), 1);
                }
            };

            /**
             * [editImage description]编辑图片模态窗
             * @param  {[obj]} image [description]被选中的图片
             * @param  {[num]} index [description]数组下标
             * @return {[type]}       [description]
             */
            $scope.editImage = function(image, index) {
                // editingCenterService.editUploaderImg(image, function(result) {
                //     $scope.list.DOC_PICTURELIST[index].PERPICURL = result.PERPICURL;
                //     $scope.list.DOC_PICTURELIST[index].APPFILE = result.APPFILE;
                //     $scope.list.DOC_PICTURELIST[index].APPDESC = result.APPDESC;
                //     delete $scope.list.DOC_PICTURELIST[index].APPENDIXID;
                // });
                // 对接媒资库
                let options = {
                    resourceType: '0',
                    isMulti: false
                };
                editingCenterService.mediaSelector(options).then(function(result) {
                    var imgName = result.list[0].previewurl.substring(result.list[0].previewurl.lastIndexOf('\/') + 1).split('?')[0];
                    $scope.list.DOC_PICTURELIST[index] = {
                        PERPICURL: result.list[0].resourceurl,
                        APPFILE: imgName,
                        APPDESC: result.list[0].resourcetitle,
                        APPSIZE: result.list[0].resourcesize,
                        meiziId: result.list[0].resourceid,
                        relationId: result.list[0].relationid
                    };
                });
            };
            // 单个删除批量上传后的图片
            $scope.deleteImg = function(ID) {
                modalDialog.confirmModal('删除', '确定删除？', function() {
                    $scope.list.DOC_PICTURELIST.splice(ID, 1);
                });
            };
            // 说明引用到全部
            $scope.declareAll = function(index) {
                modalDialog.confirmModal('同步', '确定同步该说明到其它图片？', function() {
                    var text = $scope.list.DOC_PICTURELIST[index].APPDESC;
                    angular.forEach($scope.list.DOC_PICTURELIST, function(data, key) {
                        $scope.list.DOC_PICTURELIST[key].APPDESC = text;
                    });
                });
            };
        }

        /* 融合编辑器额外功能结束*/
    }
]);
